import { useSelector } from 'react-redux'
import { METHOD } from '../constants/roles'
import { hasAccess } from '../helpers/rolesAccess'

const useAccess = () => {
  const user = useSelector((state) => state.profile)?.resp
  const userRole = user?.role

  const canAdd = (module, group) => {
    return hasAccess(userRole, { module, group, method: METHOD.POST })
  }

  const canEdit = (module, group) => {
    return hasAccess(userRole, { module, group, method: METHOD.PATCH })
  }

  const canDelete = (module, group) => {
    return hasAccess(userRole, { module, group, method: METHOD.DELETE })
  }

  const canGet = (module, group) => {
    return hasAccess(userRole, { module, group, method: METHOD.GET })
  }

  return {
    canAdd,
    canEdit,
    canDelete,
    canGet,
  }
}

export default useAccess
